import * as apiCommon from '@/api/common'
import { getDataURL } from '@/util/common'
import * as _ from 'lodash'

const file = {
  namespaced: true,
  state: {
    fileLists: []
  },
  getters: {
    getFile: (state) => (fileId) => _.find(state.fileLists, list => list.fileId === fileId)
  },
  mutations: {
    setFile(state, {fileId, dataUrl}) {
      state.fileLists.push({
        fileId: fileId,
        dataUrl: dataUrl
      })
    }
  },
  actions: {
    getFile: {
      root: true,
      async handler({ commit, getters }, fileId) {
        // storeに保存されているか確認
        const fileList = getters.getFile(fileId)
        if (fileList) return fileList

        // なければAPIで取得
        const params = { file_id: fileId }
        const save = await apiCommon
          .fetchFile({ file_id: fileId })
          .then(async (res) => {
            const save = await getDataURL(res).then((dataUrl) => {
              const save = {
                fileId: fileId,
                dataUrl: dataUrl
              }
              commit('setFile', save)
              return save
            })
            return save
          })
        return save
      }
    }
  }
}

export default file
